import styled, { css } from 'styled-components'

import checkIcon from 'assets/images/check-icon-white.svg'

import { FemiColor } from '../../constants'

export const StyledFemiOption = {
  Option: styled.button<{ isSelected: boolean }>`
    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;
    min-height: 74px;
    padding: 12px 16px;
    border: 1px solid ${FemiColor.GRAY_LIGHT};
    border-radius: 16px;
    outline: none;
    background-color: ${FemiColor.WHITE};
    color: ${FemiColor.BLACK};
    font-size: 17px;
    font-weight: 500;
    line-height: 26px;
    text-align: start;
    cursor: pointer;

    ${({ isSelected }) =>
      isSelected &&
      css`
        padding: 11px 15px;
        border: 2px solid ${FemiColor.DARK};
      `}
  `,
  Label: styled.span`
    flex: 1;
  `,
  Checkbox: styled.span<{ isChecked: boolean }>`
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 6px;
    border: 1.5px solid ${FemiColor.CHECKBOX_BORDER};
    background-position: center;
    background-repeat: no-repeat;

    ${({ isChecked }) =>
      isChecked &&
      css`
        border-color: ${FemiColor.BLACK};
        background-color: ${FemiColor.BLACK};
        background-image: url(${checkIcon});
      `}
  `,
}
